import * as api from '../services/licInstantQueue';

export const LIC_CASE_CLAIMED      = 'LIC_CASE_CLAIMED';
export const LIC_QUEUE_LOAD        = 'LIC_QUEUE_LOAD';
export const LIC_QUEUE_UPDATE      = 'LIC_QUEUE_UPDATE';
export const LIC_QUEUE_ERROR       = 'LIC_QUEUE_ERROR';
export const LIC_DOCTOR_STATE_SET  = 'LIC_DOCTOR_STATE_SET';
export const LIC_CALL_STARTED      = 'LIC_CALL_STARTED';

export const loadOpsState = () => async (dispatch) => {
  try {
    const data = await api.getOpsState();
    dispatch({ type: LIC_QUEUE_LOAD, payload: data });
  } catch (err) {
    dispatch({ type: LIC_QUEUE_ERROR, payload: err.message });
  }
};

export const applyOpsUpdate = (payload) => ({
  type: LIC_QUEUE_UPDATE,
  payload,
});

export const doManualAssign = (consultationId, doctorId) => async (dispatch) => {
  await api.manualAssign(consultationId, doctorId);
};

export const loadDoctorState = () => async (dispatch) => {
  try {
    const data = await api.getDoctorState();
    dispatch({ type: LIC_DOCTOR_STATE_SET, payload: data });
  } catch (err) {
    dispatch({ type: LIC_QUEUE_ERROR, payload: err.message });
  }
};

export const changeDoctorStatus = (status) => async (dispatch) => {
  try {
    await api.setDoctorStatus(status);
    dispatch(loadDoctorState());
  } catch (err) {
    dispatch({ type: LIC_QUEUE_ERROR, payload: err.message });
  }
};

export const doStartCall = (consultationId) => async (dispatch) => {
  try {
    const data = await api.startCall(consultationId);
    dispatch({ type: LIC_CALL_STARTED, payload: data });
    return data;
  } catch (err) {
    dispatch({ type: LIC_QUEUE_ERROR, payload: err.message });
    return null;
  }
};

export const doCompleteCall = (consultationId) => async (dispatch) => {
  try {
    await api.completeCall(consultationId);
    dispatch(loadDoctorState());
  } catch (err) {
    dispatch({ type: LIC_QUEUE_ERROR, payload: err.message });
  }
};

export const doClaimCase = (consultationId) => async (dispatch) => {
  try {
    const data = await api.claimCase(consultationId);
    if (data && data.status === 'success') {
      dispatch({ type: LIC_CALL_STARTED, payload: data });
    }
    return data;
  } catch (err) {
    dispatch({ type: LIC_QUEUE_ERROR, payload: err.message });
    return null;
  }
};

export const setOpsDoctorStatus = (doctorId, status) => async (dispatch) => {
  try {
    await api.setOpsDoctorStatus(doctorId, status);
    dispatch(loadOpsState());
  } catch (err) {
    dispatch({ type: LIC_QUEUE_ERROR, payload: err.message });
  }
};

export const doRegisterInstantCase = (payload) => async (dispatch) => {
  try {
    const data = await api.registerInstantCase(payload);
    if (data && (data.status === 'success' || data.status === 'duplicate')) {
      dispatch(loadOpsState());
    }
    return data;
  } catch (err) {
    dispatch({ type: LIC_QUEUE_ERROR, payload: err.message });
    return { status: 'failure', errorMessage: err.message };
  }
};

export const doBulkGenerateInstantLinks = (proposalNumbers) => async (dispatch) => {
  try {
    const data = await api.bulkGenerateInstantLinks(proposalNumbers);
    if (data && data.status === 'success') {
      dispatch(loadOpsState());
    }
    return data;
  } catch (err) {
    dispatch({ type: LIC_QUEUE_ERROR, payload: err.message });
    return { status: 'failure', errorMessage: err.message };
  }
};
